module.exports = __webpack_public_path__ + "img/honda-nsx-car.73765c6b.jpg";